@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  width: auto;
  height: 360px;

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}

.rv-header-container {
  display: flex;
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
}

.rv-financial-ratios {
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 8px;
  height: 100%;
}

.rv-financial-ratio-container-item {
  display: flex;
  flex-grow: 1;
  padding-top: 8px;
  border-bottom: thin solid #e0e0e0;
  padding-bottom: 8px;
  justify-content: space-between;
  overflow: visible;

  &:last-child {
    border-bottom: none;
  }
}

.rv-financial-ratio-info {
  display: flex;
  flex-direction: column;

  .rv-ratio-name {
    display: flex;
    line-height: 1.5;
    color: #424242;
    font-size: 12px;
    font-weight: 600;

    .rv-ratio-name-text {
      padding-left: 4px;
    }
  }

  .rv-ratio-values {
    display: flex;
    flex-grow: 1;
    align-items: center;

    .rv-ratio-summary {
      line-height: 1.5;
      font-size: 20px;
      max-width: 70%;
      font-weight: 700;
      margin-right: 8px;
    }
  }
}

.rv-select {
  border: 0;
  font-size: 14px;
}
